import purify from "dompurify";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { Button, Modal } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import {
    DUNNINGS_MODAL_STYLES,
    DUNNINGS_POP_UP_CTA_LOCATION,
    DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME,
    REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME,
} from "app/components/Dunnings/dunningsConstants";
import {
    DunningsModalLeft,
    DunningsModalLeftImage,
    DunningsModalRight,
} from "app/components/Dunnings/DunningsModal/DunningsModalStyled";
import { ReactivateAccountDunningList } from "app/components/Dunnings/ReactivateAccountDunningList/ReactivateAccountDunningList";
import { useDunningsModal } from "app/components/Dunnings/useDunningsModal";
import { useDunnings } from "app/components/hooks/useDunnings";
import { AssetsService } from "app/services/AssetsService";

export const ReactivateAccountModal = () => {
    const { onDunningsButtonClicked } = useDunnings();
    const { isOpen, onCloseClicked } = useDunningsModal({
        eventName: REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME,
        eventSubSubName: DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME,
    });
    const translate = useTranslation();

    return (
        <Modal
            isOpen={isOpen}
            customStyles={DUNNINGS_MODAL_STYLES}
            data-automation="reactivate-account-modal"
        >
            <Flex>
                <DunningsModalLeft>
                    <Text
                        fontVariant="h3"
                        type="DM Sans"
                        style={{ padding: "0 40px" }}
                        dangerouslySetInnerHTML={{
                            // eslint-disable-next-line @typescript-eslint/naming-convention
                            __html: purify.sanitize(translate("dunnings.reactivateAccount.modal.title")),
                        }}
                    />

                    <DunningsModalLeftImage
                        alt={translate("dunnings.reactivateAccount.modal.image_alt")}
                        src={AssetsService.assetUrl("/images/dunnings/unlock_feature.svg")}
                    />
                </DunningsModalLeft>

                <DunningsModalRight>
                    <Stack gap="30px">
                        <Text
                            fontVariant="body2"
                            type="DM Sans"
                            style={{ width: "100%" }}
                            dangerouslySetInnerHTML={{
                                // eslint-disable-next-line @typescript-eslint/naming-convention
                                __html: purify.sanitize(translate("dunnings.reactivateAccount.modal.text")),
                            }}
                        />

                        <ReactivateAccountDunningList
                            listHeaderText={translate("dunnings.reactivateAccount.modal.by_renewing")}
                        />
                    </Stack>

                    <Stack gap="8px">
                        <Button
                            type="primary"
                            onClick={() =>
                                onDunningsButtonClicked(
                                    `${REACTIVATE_ACCOUNT_DUNNING_EVENT_NAME}/${DUNNINGS_POP_UP_CTA_LOCATION}/${DUNNINGS_REACTIVATE_ACCOUNT_EVENT_SUB_SUB_NAME}`,
                                    "package",
                                )
                            }
                            style={{ width: "100%", fontFamily: "DM Sans" }}
                        >
                            {translate("dunnings.reactivateAccount.modal.update_payment")}
                        </Button>

                        <Button
                            type="flat"
                            onClick={onCloseClicked}
                            style={{ width: "100%", fontFamily: "DM Sans" }}
                        >
                            {translate("dunnings.reactivateAccount.modal.close")}
                        </Button>
                    </Stack>
                </DunningsModalRight>
            </Flex>
        </Modal>
    );
};
